<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="c1a"></a>
</div>
<p class="date">4:30 A.M.</p>
<p>Edward Bonny and his wife, Pat, had taken Monday off. Both had experienced premonitions the evening before. It was as if some cloud were hanging over their heads—some tremendous
  cloud—and they both had taken it as a warning not to go to the World Trade Center that day. They heeded the warning.</p>
<p>On Monday evening, they each once again had the same premonition. Ed usually followed his first instincts. He acknowledged that they shouldn’t go to the World Trade Center on Tuesday also,
  but began to rationalize the premonition … and he knew it was a mistake.</p>
<p>Ed had retired from the Port Authority of New York and New Jersey many years ago and was now employed as a consultant. As such, Ed got paid only when he presented himself for work, and on
  Tuesday, Pat, a Port Authority employee, had a training class in the North Tower.</p>
<p>Ed took their destiny into his own hands—they had, after all, taken Monday off without consequence—and made the decision to overrule Divine Inspiration. When his 4:30 a.m. alarm went
  off on Tuesday, September 11, it was business as usual.</p>
<p class="center"></p>
<p class="noindent">It was time for Nancy Seliga to get up.</p>
<p>A Port Authority employee since she graduated from high school at age seventeen, Nancy was the building manager for the North Tower, One World Trade Center. While she loved her job, rolling out
  of bed was a little more difficult than normal this morning because she and her husband, Chuck, had just the day before returned from a long overdue and well-deserved four-day weekend of rest and
  relaxation in Delaware. It was also Chuck’s birthday this Friday, and Nancy was planning a party. However, despite these distractions, Nancy was looking forward to getting back to work.</p>
<p>Driving the nine miles from her home to the New Jersey Transit train station, Nancy couldn’t help but notice what a clear and beautiful day was dawning. <em>It’s going to be a good
  day</em>, she thought, getting back into the groove of a familiar routine.</p>
<p class="center"> </p>
<p class="date2">5:00 A.M.</p>
<p>Jerrold M. Dinkels considered himself a modest man—an average suburban guy, born and raised in Brooklyn, New York. Married twenty-eight years to his beautiful wife, Mary Ellen, they had
  three children: Marissa, about to turn twenty-three, was a nurse; Alex, age twenty-four, was in finance; and Michael, age twenty-five, was in medical school.</p>
<p>Jerry was employed by the Port Authority as an engineering program manager. Today, like every other day, he followed his normal routine. He awoke to his alarm at 5:00 a.m., kissed Mary Ellen
  good-bye, and went to the gym at 5:30 for an hour’s workout and a shower, before taking the 7:00 a.m. LIRR—Long Island Rail Road—from his home in Oceanside, New York, to Penn
  Station, New York City. It was a normal day, with the exception of the clarity—spectacular! “On a clear day, you can see forever,” he hummed, thinking of that old Alan Jay Lerner
  favorite.</p>
<p> </p>
<p class="date2">5:30 A.M.</p>
<p>“The time is 5:30 a.m., Tuesday morning, and it is going to be a clear and beautiful day in New York City,” the radio announcer broadcast to eighteen million inhabitants in the
  greater metropolitan area.</p>
<p>“Rise and shine, Erik,” Sarah murmured cheerfully to her husband, Erik Ronningen, as he flung his right arm out to turn off the clock radio. “Don’t forget,” she
  reminded him, “You’ve got your meeting with Doug Karpiloff today.” She was referring to a 9:00 a.m. meeting that would change Erik’s job status from a temporary, long-term
  consultant with the Port Authority of New York and New Jersey to a position as a full-time employee … with all the benefits.</p>
<p>Erik completed his morning ablutions, and dressed in a dark-blue pinstripe suit, white shirt, striped red tie, and new black Florsheim wing-tip shoes. He arrived at the Mamaroneck train platform
  in Westchester, New York, to await the 6:24 a.m. Metro-North train to New York City’s Grand Central Terminal.</p>
<p>“Good morning, Walter,” he offered, and the greeting was returned in kind. After six months of standing not two feet from each other, Erik had introduced himself to Walter
  Chronowski. It became a fast friendship, like reuniting with a close school chum after decades of separation.</p>
<p>Walter and Erik conversed on the trip to Grand Central Terminal, and both walked to the Grand Central subway station, getting on the IRT number-four express train to Brooklyn. As the express
  approached Walter’s Fourteenth Street stop, Walter mentioned to Erik that there should be plenty of tourists visiting the World Trade Center’s observation deck that day.</p>
<p>“With today’s conditions and clear visibility,” Erik replied, “the observation deck will be packed.”</p>
<p>Shaking hands, Walter said, “Have a good day, Erik.”</p>
<p>“And you too, Walter. See you tomorrow.”</p>
<p>A couple of stops later, Erik got off at Fulton Street and exited the subway system into
      bright, beautiful daylight. The Twin Towers of the World Trade Center were brilliantly
      silhouetted by an azure-blue New Jersey sky. The day reminded him of his youth, working
      summers at the Leesburg, Virginia, airport, and he thought to himself, <em>a great day for
        flying</em> …</p>
<p class="center"> </p>
<p class="date2">6:00 A.M.</p>
<p>Having punched the snooze button on the clock radio one too many times, Sonia Henriquez was running a little late—having just returned from a fabulous Caribbean vacation. She jumped out of
  bed, washed, put on her beige suit, drank a quick cup of coffee, and ran for the bus.</p>
<p>Sonia worked for the Port Authority on the sixty-eighth floor in Tower One. She wasn’t
      required to be at her desk until nine, but preferred to be there no later than 8:45.
      Conscientious, she liked to get in a little early to organize her day. Sonia sighed; the day
      had just begun and already she was off her routine. Taking a deep breath, she tried to
      envision the soothing beaches of the Caribbean—peaceful memories that were fading all
      too quickly …</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_c1a.vue?564e1ca6